module.exports = __webpack_public_path__ + "static/img/testimony (88).4c6c5997.jpg";